import { RouteLocationNormalized } from 'vue-router'
import { queryClient } from '@/composables/queries/query_client'
import { PropertyType } from '@/interfaces'

async function redirectToHome(to: RouteLocationNormalized) {
  try {
    const unitIdAsNumber = parseInt(to.params.unitId as string, 10)
    const properties = await queryClient.fetchQuery<PropertyType[]>({
      queryKey: ['properties']
    })

    const targetProperty = properties?.find((property) =>
      property.units?.some((unit) => unit.id === unitIdAsNumber)
    )

    const hasSolarbotUnitsForUnit =
      !!targetProperty && targetProperty.solarbot_units.length > 0

    if (hasSolarbotUnitsForUnit) {
      return { name: 'Home' }
    }
    return true
  } catch (error) {
    console.error('Failed to fetch properties:', error)
    return { name: 'Home' }
  }
}

const routesSolarMode = [
  {
    path: '/solar-mode/:unitId/personalise',
    name: 'SolarModePersonalise',
    meta: {
      title: 'Solar mode',
      backgroundTheme: 'brand-light'
    },
    component: () =>
      import('@/views/automations/solar-mode/SolarModeSummaryView.vue'),
    beforeEnter: [redirectToHome]
  },
  {
    path: '/solar-mode/:unitId/set-sunny-times',
    name: 'SolarModeSetSunnyTimes',
    component: () =>
      import('@/views/automations/solar-mode/SolarModeSummaryView.vue'),
    meta: {
      title: 'Solar mode'
    },
    beforeEnter: [redirectToHome]
  },
  {
    path: '/solar-mode/:unitId/set-temperatures',
    name: 'SolarModeSetTemperatures',
    component: () =>
      import('@/views/automations/solar-mode/SolarModeSummaryView.vue'),
    meta: {
      title: 'Solar mode'
    }
  },
  {
    path: '/solar-mode/:unitId/calibrating',
    name: 'SolarModeHotBotCalibrating',
    component: () =>
      import('@/views/automations/solar-mode/SolarModeSummaryView.vue'),
    meta: {
      title: 'Solar mode'
    },
    beforeEnter: [redirectToHome]
  },
  {
    path: '/solar-mode/:unitId/summary',
    name: 'SolarModeSummary',
    component: () =>
      import('@/views/automations/solar-mode/SolarModeSummaryView.vue'),
    meta: {
      title: 'Solar mode'
    },
    beforeEnter: [redirectToHome]
  },
  {
    path: '/solar-mode/:unitId/edit',
    name: 'SolarModeEditPreferences',
    component: () =>
      import('@/views/automations/solar-mode/SolarModeSummaryView.vue'),
    meta: {
      title: 'Solar mode'
    },
    beforeEnter: [redirectToHome]
  }
]

export default routesSolarMode
